import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { router } from "./App";
import reportWebVitals from "./reportWebVitals";
import { BootstrapGuard } from "./lib/apiGuard/bootstrapGuard";

// A1: Bootstrap reload frequency check — must run before root.render().
// If reload loop detected, renders static HALT screen and skips React mount.
if (!BootstrapGuard.check()) {
  // HALT: static screen already injected by BootstrapGuard.check()
} else {
  // グローバルエラーハンドラ（React外のエラーキャッチ）
  window.onerror = (message, source, lineno, colno, error) => {
    console.error('Global error caught:', { message, source, lineno, colno, error });
  };

  window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    console.error('Unhandled promise rejection:', event.reason);
  };

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <RouterProvider router={router} />
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
